import { PageLayout } from "../components/PageLayout";
import { useDocumentMeta } from "../lib/router";

export function PrivacyPage() {
  useDocumentMeta({
    title: "プライバシーポリシー | 食べログ ラーメン百名店マップ",
    description:
      "食べログ ラーメン百名店マップの個人情報の取り扱い、Cookie の使用、Google Maps Platform および Google AdSense の利用に関するプライバシーポリシーです。",
  });

  return (
    <PageLayout title="プライバシーポリシー" lastUpdated="2026-04-13">
      <p>
        本プライバシーポリシーは、食べログ ラーメン百名店マップ
        (以下「本サイト」といいます) がユーザーから取得する情報の種類、利用目的、
        第三者提供の有無等について定めるものです。
      </p>

      <h2>1. 取得する情報</h2>
      <p>
        本サイトは、ユーザーから氏名・メールアドレス・住所・電話番号などの
        個人情報を直接取得することはありません。ただし、本サイトの運営に
        伴い以下の情報が自動的に取得される場合があります。
      </p>
      <ul>
        <li>IP アドレス、ブラウザ種別、OS 種別、リファラ、アクセス日時</li>
        <li>
          Cookie およびそれに類するローカルストレージ等に保存された識別子
        </li>
        <li>
          ユーザーが本サイト上で行った操作 (クリック・スクロール等) の匿名統計
        </li>
      </ul>

      <h2>2. Cookie の使用について</h2>
      <p>
        本サイトではユーザー体験の向上および広告配信・アクセス解析のために
        Cookie を使用する場合があります。ユーザーはブラウザ設定により
        Cookie の受け入れを拒否することができますが、その場合は本サイトの
        一部機能が正常に動作しないことがあります。
      </p>

      <h2>3. Google Maps Platform の利用</h2>
      <p>
        本サイトは地図の描画・店舗情報 (場所・評価・写真・営業時間等) の取得に
        Google 社が提供する Google Maps Platform (Maps JavaScript API および
        Places API) を使用しています。地図を表示した際、ユーザーの IP アドレスや
        ブラウザ情報等が Google 社に送信される場合があります。詳細は以下をご確認ください。
      </p>
      <ul>
        <li>
          <a
            href="https://policies.google.com/privacy?hl=ja"
            target="_blank"
            rel="noreferrer noopener"
            className="text-sky-400 underline underline-offset-2 hover:text-sky-300"
          >
            Google プライバシーポリシー
          </a>
        </li>
        <li>
          <a
            href="https://www.google.com/help/terms_maps/"
            target="_blank"
            rel="noreferrer noopener"
            className="text-sky-400 underline underline-offset-2 hover:text-sky-300"
          >
            Google マップ / Google Earth 追加利用規約
          </a>
        </li>
      </ul>

      <h2>4. Google AdSense について</h2>
      <p>
        本サイトは将来的に第三者配信の広告サービス「Google AdSense」を利用する
        可能性があります。Google を含む第三者配信事業者は、Cookie を使用して
        ユーザーが過去に本サイトや他のサイトにアクセスした際の情報に基づいて
        広告を配信することがあります。
      </p>
      <p>
        ユーザーは{" "}
        <a
          href="https://adssettings.google.com/"
          target="_blank"
          rel="noreferrer noopener"
          className="text-sky-400 underline underline-offset-2 hover:text-sky-300"
        >
          Google 広告設定
        </a>{" "}
        ページにて、パーソナライズ広告の配信を無効にすることができます。
        また{" "}
        <a
          href="https://www.aboutads.info/choices/"
          target="_blank"
          rel="noreferrer noopener"
          className="text-sky-400 underline underline-offset-2 hover:text-sky-300"
        >
          www.aboutads.info
        </a>{" "}
        で第三者配信事業者のパーソナライズ広告を無効にすることもできます。
      </p>
      <p>
        第三者配信による広告掲載の際に使用される Cookie および詳細については、
        Google のポリシーおよび規約ページ (
        <a
          href="https://policies.google.com/technologies/ads?hl=ja"
          target="_blank"
          rel="noreferrer noopener"
          className="text-sky-400 underline underline-offset-2 hover:text-sky-300"
        >
          広告に関する Google のポリシー
        </a>
        ) をご確認ください。
      </p>

      <h2>5. アクセス解析ツールについて</h2>
      <p>
        本サイトはアクセス解析のために Cloudflare Workers / Analytics 等の
        ツールを利用する場合があります。これらは Cookie 等を用いて匿名の
        トラフィック情報を収集するもので、個人を特定する情報は収集しません。
      </p>

      <h2>6. 個人情報の第三者提供</h2>
      <p>
        本サイトは、法令に基づく場合を除き、取得した情報を第三者に提供する
        ことはありません。
      </p>

      <h2>7. お問い合わせ</h2>
      <p>
        本ポリシーに関するお問い合わせは、本サイト運営者までご連絡ください。
      </p>

      <h2>8. プライバシーポリシーの変更</h2>
      <p>
        本ポリシーの内容は、法令の変更や本サイトの運用方針の変更等により、
        予告なく変更されることがあります。最新の内容は常に本ページにて
        掲載するものとします。
      </p>
    </PageLayout>
  );
}
